export default __webpack_public_path__ + "static/Martbook-28587bd11f03bd568331f3f105d47d7d.webp";